import _ from 'lodash';
window._ = _;

try {
    require('bootstrap');
} catch (e) {}
